import service from '@/plugins/service'

const userApi = {}

userApi.getCaptcha = username => {
  return service({
    url: `/sendCaptcha?username=${username}`,
    method: 'post'
  })
}

/* 
  明文密码登录 get https://ygk.deman.cn/api/login?username=&password=&code=
  密文密码登录 post https://ygk.deman.cn/api/login form-data参数：username，password，code
*/

userApi.login = (loginParam, type) => {
  // const formData = new FormData()
  // formData.append('username', loginParam.username)
  // formData.append('password', loginParam.password)
  // return service({
  //   url: '/login',
  //   method: 'post',
  //   data: formData
  // })
  if(type) {
    const formData = new FormData()
    formData.append('username', loginParam.username)
    formData.append('password', loginParam.password)
    // formData.append('code', loginParam.code)
    return service({
      url: '/login',
      method: 'post',
      data: formData
    })
  } else {
    return service({
      url: '/login',
      params: loginParam
    })
  }
}

userApi.logout = () => {
  return service({
    url: '/logout',
    method: 'get'
  })
}

userApi.getMenu = () => {
  return service({
    url: '/menu',
    method: 'get'
  })
}

userApi.getUserList = (current = 1, size = 50) => {
  return service({
    url: `/admin/user/list/${current}/${size}`,
    method: 'get'
  })
}

userApi.searchUserList = (current = 1, size = 50, searchParam) => {
  return service({
    url: `/admin/user/list/search/${current}/${size}`,
    method: 'get',
    params: {
      name: searchParam.name,
      username: searchParam.username,
      companyName: searchParam.companyName
    }
  })
}

userApi.getRoleList = () => {
  return service({
    url: '/admin/role/list',
    method: 'get'
  })
}

userApi.getUserRoles = (userId) => {
  return service({
    url: `/admin/user/get/${userId}/roles`,
    method: 'get'
  })
}

userApi.updateUserRole = (userId, roleIds) => {
  return service({
    url: `/admin/user/update/${userId}`,
    method: 'post',
    data: roleIds
  })
}

userApi.getAllPermission = () => {
  return service({
    url: '/admin/permission/listAll',
    method: 'get'
  })
}

userApi.getRolePermission = (roleId) => {
  return service({
    url: `/admin/permission/list/${roleId}`,
    method: 'get'
  })
}

userApi.updateRolePermission = (roleId, permissionIds) => {
  const list = []
  permissionIds.forEach(id => list.push({ id: id }))
  return service({
    url: `/admin/permission/update/${roleId}`,
    method: 'post',
    data: list
  })
}

userApi.saveRole = (role) => {
  return service({
    url: '/admin/role/save',
    method: 'post',
    data: role
  })
}

userApi.deleteRole = (roleId) => {
  return service({
    url: `/admin/role/delete/${roleId}`,
    method: 'post'
  })
}

export default userApi
